import {useEffect} from 'react'
import {useOrganization} from 'organization/OrganizationProvider'
import {useEvent} from 'Event/EventProvider'
import {useEventMarketplaceClient} from 'lib/marketplace-api/use-event-marketplace-client'
import {useThankYouPage} from 'lib/marketplace-api/thank-you-page/use-thank-you-page'
import {useCreateThankYouPage} from 'lib/marketplace-api/thank-you-page/use-create-thank-you-page'

export default function useAutoCreateThankYouPage() {
  const {event} = useEvent()
  const {organization} = useOrganization()
  const {client} = useEventMarketplaceClient()

  const {
    data: thankYouPage,
    isLoading,
    isSuccess: fetchedThankYouPage,
  } = useThankYouPage({
    event,
  })

  const createThankYouPage = useCreateThankYouPage({
    organization,
    event,
  })

  useEffect(() => {
    if (
      !fetchedThankYouPage ||
      thankYouPage ||
      createThankYouPage.isLoading ||
      !client
    ) {
      return
    }

    createThankYouPage.mutate({client})
  }, [fetchedThankYouPage, thankYouPage, createThankYouPage, client])

  if (isLoading) {
    return {
      isLoading,
      thankYouPage: undefined,
    }
  }

  return {
    isLoading,
    thankYouPage: thankYouPage,
  }
}
